import { useCallback, useEffect, useState } from "react";

import client from "Libs/platform";

type PaymentSourcesAllowedResponse = {
  items: Array<{
    id: string;
    label: string;
    stripe_public_key: string;
  }>;
};

export const useOrganizationAllowedPaymentSources = (
  organizationId: string
) => {
  const [allowedPaymentSources, setPaymentSources] =
    useState<PaymentSourcesAllowedResponse["items"]>();
  const [isLoading, setIsLoading] = useState(false);

  const load = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = (await client.getOrganizationPaymentSourcesAllowed(
        organizationId
      )) as PaymentSourcesAllowedResponse;
      setPaymentSources(response.items);
    } finally {
      setIsLoading(false);
    }
  }, [organizationId]);

  useEffect(() => {
    if (!allowedPaymentSources) load();
  }, [load, allowedPaymentSources]);

  return { allowedPaymentSources, isLoading, load };
};
